'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding: 8px 16px;\n  margin-bottom: ", ";\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  padding: 8px 16px;\n  margin-bottom: ", ";\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n\n  &:hover {\n    background: ",
    ";\n  }\n"])), function (_a) {
    var lastItem = _a.lastItem;
    return (lastItem ? '0' : '8px');
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    return (active ? theme.colors.greys.adminGreyMedium : theme.colors.universal.white);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    var _b = theme.colors.greys, adminGreyMedium = _b.adminGreyMedium, adminGreyLight = _b.adminGreyLight;
    return active ? adminGreyMedium : adminGreyLight;
});
var Text = styled__default.span(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var templateObject_1, templateObject_2;

exports.Container = Container;
exports.Text = Text;
